import React, { FC, useEffect } from 'react';

import { Fit, Layout, useRive } from '@rive-app/react-canvas';
import { useTranslation } from 'react-i18next';

import { introAnimationData } from '~/modules/feature-access/components/IntroAnimation/data';
import { onAssetLoad } from '~/utils/animations';

import { IntroAnimationVariant } from './types';

type Props = {
  variant: IntroAnimationVariant;
};

const IntroAnimation: FC<Props> = ({ variant }) => {
  const { t } = useTranslation('modal');

  const { src, getTexts } = introAnimationData[variant];

  const { rive, RiveComponent } = useRive({
    src: src,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
    }),
    assetLoader: onAssetLoad,
  });

  useEffect(() => {
    if (rive) {
      getTexts(t).forEach(({ runName, text }) => {
        rive.setTextRunValue(runName, text);
      });
    }
  }, [rive]);

  return <RiveComponent />;
};

export default IntroAnimation;
